module.exports = __webpack_public_path__ + "img/function_search.c9123edf.png";